// src/pages/FSP4AllForecasting.js

import React from 'react';
import TopBar from '../components/TopBar';

const FSP4AllForecasting = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="fsp4all-forecasting" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="p-6 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-100">
              <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <h3 className="text-lg font-semibold mb-2">FSP4All Forecasting Tool</h3>
            <p className="text-gray-600 mb-4">Advanced demand forecasting and supply planning for vaccine supply chains.</p>
            <p className="text-gray-500">This module is under development. Coming soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FSP4AllForecasting; 